<div class="p-2">
	@if (pageFunction === 'add') {
		<button mat-raised-button color="warn" class="me-3" (click)="openKrsDialog()">Pobierz dane z KRS</button>
	}
	<button mat-raised-button color="accent" (click)="submitOrganization()" class="me-3">Zapisz</button>
	@if (!editable && pageFunction === 'edit') {
		<button mat-raised-button color="warn" class="me-3" (click)="editUnlock()">Edycja</button>
	}
</div>
<fieldset [disabled]="!editable">
	<div class="row row-no-padding mx-2">
		<div class="col-4 px-2">
			<h3 class="py-2">Dane Organizacji</h3>
			<div class="d-flex flex-column gap-3 p-2">
				<mat-slide-toggle [(ngModel)]="organizationService.organizationData.isOskar" [disabled]="!editable">
					Należy do Grupy Oskar?
				</mat-slide-toggle>
				<mat-slide-toggle [(ngModel)]="organizationService.organizationData.isActive" [disabled]="!editable">
					Aktywna?
				</mat-slide-toggle>
			</div>
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="shortName"
					name="shortName"
					required
					[(ngModel)]="organizationService.organizationData.shortName"
					placeholder="Krótka nazwa"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="fullName"
					name="fullName"
					required
					[(ngModel)]="organizationService.organizationData.name"
					placeholder="Pełna nazwa"
				/>
			</mat-form-field>

			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="regon"
					name="regon"
					maxlength="9"
					[(ngModel)]="organizationService.organizationData.regon"
					placeholder="REGON"
					pattern="[0-9]{9,14}"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="nip"
					name="nip"
					maxlength="30"
					required
					[(ngModel)]="organizationService.organizationData.nip"
					pattern="[0-9a-zA-Z]{10,30}"
					placeholder="NIP"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="krs"
					name="krs"
					maxlength="10"
					[(ngModel)]="organizationService.organizationData.krs"
					placeholder="KRS"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="number"
					id="navigatorId"
					name="navigatorId"
					[(ngModel)]="organizationService.organizationData.nawigatorID"
					placeholder="ID Nawigatora"
				/>
			</mat-form-field>

			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="merlinxCode"
					name="merlinxCode"
					[(ngModel)]="organizationService.organizationData.codeMerlinx"
					placeholder="Kod MerlinX"
				/>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="number"
					id="agencyMerlinx"
					name="agencyMerlinx"
					[(ngModel)]="organizationService.organizationData.agencyMerlinx"
					placeholder="Numer agencyjny"
				/>
			</mat-form-field>
			@if (!organizationService.organizationData.isOskar) {
				<mat-form-field class="w-100">
					<mat-select
						id="organizationType"
						name="organisaionType"
						[(ngModel)]="organizationService.organizationData.sellCategory"
						placeholder="Kategoria sprzedaży"
						[disabled]="!editable"
					>
						@for (item of organizationService.enterpriseData.sellCategory; track item.id) {
							<mat-option [value]="item.id">{{ item.name }} </mat-option>
						}
					</mat-select>
				</mat-form-field>
			}
			<mat-form-field class="w-100">
				<mat-select
					id="organizationCoop"
					name="organizationCoop"
					placeholder="Rodzaj współpracy"
					[(ngModel)]="organizationService.organizationData.kindCooperation"
					[disabled]="!editable"
				>
					@for (item of cooperationSet; track item.key) {
						<mat-option [value]="item.key">{{ item.value }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					id="gratyfikantTableName"
					name="gratyfikantTableName"
					[(ngModel)]="organizationService.organizationData.gratyfikantTableName"
					placeholder="Nazwa bazy danych Gratyfikant"
				/>
			</mat-form-field>
		</div>
		<div class="col-8 px-4 d-flex flex-column justify-content-between">
			<div>
				<div class="d-flex justify-content-between flex-row my-2">
					<h3>Adresy firmowe:</h3>
					<button mat-raised-button color="primary" [disabled]="!editable" (click)="openAddressAdd()">
						<i class="fa-solid fa-book"></i> Dodaj adres firmowy
					</button>
				</div>
				<div class="table-container">
					<mat-table #dataTableAddress [dataSource]="matDataAddress">
						<ng-container matColumnDef="location">
							<mat-header-cell *matHeaderCellDef> Miasto</mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{ element.location?.name }} &nbsp;
								<small> ({{ element.location?.parentLocation?.name }}) </small>
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="kind">
							<mat-header-cell *matHeaderCellDef> Typ</mat-header-cell>
							<mat-cell *matCellDef="let element">{{ addressMapping[element.kind] }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="zipCode">
							<mat-header-cell *matHeaderCellDef> Kod pocztowy</mat-header-cell>
							<mat-cell *matCellDef="let element">{{ element.zipCode }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="address">
							<mat-header-cell *matHeaderCellDef> Adres</mat-header-cell>
							<mat-cell *matCellDef="let element">{{ element.address }}</mat-cell>
						</ng-container>
						<ng-container matColumnDef="edit">
							<mat-header-cell *matHeaderCellDef></mat-header-cell>
							<mat-cell *matCellDef="let element">
								<button
									mat-raised-button
									color="accent"
									[disabled]="!editable"
									(click)="openAddressEdit(element)"
								>
									Edytuj
								</button>
							</mat-cell>
						</ng-container>
						<mat-header-row *matHeaderRowDef="addressColumns; sticky: true"></mat-header-row>
						<mat-row *matRowDef="let row; columns: addressColumns"></mat-row>
					</mat-table>
				</div>
			</div>
			<div class="">
				<div class="d-flex justify-content-between flex-row my-4">
					<h3>Działy:</h3>
					<button
						mat-raised-button
						class="contact-add-button"
						color="primary"
						[disabled]="!editable"
						(click)="openContactAdd()"
					>
						<i class="fa-solid fa-address-book"></i> Dodaj działy
					</button>
				</div>
				<div class="table-container">
					<mat-table #dataTableContacts [dataSource]="matDataContacts" cdkDropList cdkDropListDisabled="true">
						<ng-container matColumnDef="department">
							<mat-header-cell *matHeaderCellDef> Dział</mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{ element.kind.name }}
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="departmentNumber">
							<mat-header-cell *matHeaderCellDef> Numer telefonu</mat-header-cell>
							<mat-cell *matCellDef="let element">
								<ul>
									@for (phone of element.departmentContacts; track phone) {
										<li>
											{{ phone.phone }}
										</li>
									}
								</ul>
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="departmentEmail">
							<mat-header-cell *matHeaderCellDef> Adres email</mat-header-cell>
							<mat-cell *matCellDef="let element" class="d-flex align-items-center">
								<ul>
									@for (email of element.departmentContacts; track email) {
										<li>
											{{ email.email }}
										</li>
									}
								</ul>
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="userResponsibility">
							<mat-header-cell *matHeaderCellDef>Osoba odpowiedzialna</mat-header-cell>
							<mat-cell *matCellDef="let element">
								@if (element.userResponsibility !== null) {
									<div>
										{{ element.userResponsibility.firstName }}
										{{ element.userResponsibility.lastName }}
									</div>
								}
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="edit">
							<mat-header-cell *matHeaderCellDef></mat-header-cell>
							<mat-cell *matCellDef="let element">
								<button
									mat-raised-button
									color="accent"
									class="contact-edit-button"
									[disabled]="!editable"
									(click)="openContactEdit(element)"
								>
									Edytuj
								</button>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="contactColumns; sticky: true"></mat-header-row>
						<mat-row *matRowDef="let row; columns: contactColumns"></mat-row>
					</mat-table>
				</div>
			</div>
			@if (false) {
				<h1 class="align-self-end">
					Saldo:
					{{ organizationService.organizationData.balance | price }} zł
				</h1>
			}
		</div>
	</div>
</fieldset>
